<template>
  <div>
    <div class="container">
      <div class="title">亲爱的携康用户：</div>
      <div class="list-text">
        您在申请注销携康账户中点击同意前，应当认真阅读本《携康账户注销协议》（以下称“《注销协议》”）。
      </div>
      <div class="list-text">
        请您务必审慎阅读、充分理解《注销协议》中相关条款内容，其中包括：
      </div>
      <div class="list-text">1、与您约定免除或限制责任的条款；</div>
      <div class="list-text">2、其他以粗体标识的重要条款。</div>
      <div class="list-text">
        【特别提示】当您按照注销页面提示填写信息、阅读并同意本《注销协议》及相关条款与条件且完成账户注销后， 即表示您已充分阅读、理解并接受本《注销协议》的全部内容。阅读本《注销协议》的过程中，如果您不同意相关任何条款和条件约定，请您立即停止注销账户。
      </div>
      <div class="list-text">我们在此善意地提醒您， 您注销账户的行为会给您的售后维权带来诸多不便，且注销携康账户后， 您的个人信息我们会在携康的前台系统中去除，使其保持不可被检索、访问的状态，或对其进行匿名化处理。</div>
      <div>
        <div class="title-subhead">1.如果您仍执意注销账户，您的账户需同时满足以下条件：</div>
        <div class="list-text">
          (1)您自愿放弃账户在携康的资产和虚拟权益（包括但不限于红包、账户余额、健康币、优惠券、权益、积分、资格等）；
        </div>
        <div class="list-text">
          (2)账户内无未完成的携康的订单和服务；
        </div>
        <div class="list-text">
          (3)账户无正在进行中的投诉举报或被投诉举报；
        </div>
        <div class="list-text">
          (4)账户已经解除与其他网站、其他APP的授权登录或绑定关系；
        </div>
        <div class="list-text">
          (5)账户当前为有效账户，非冻结状态；
        </div>
        <div class="list-text">
          (6)实名账户已解除实名信息。
        </div>
      </div>
      <div>
        <div class="title-subhead">2.携康账户一旦被注销将不可恢复，您在携康的一切医疗健康服务将结束，您的身份信息、账户信息、优惠信息等权益将被清空， 且无法恢复，请您在操作之前自行备份携康账户相关的所有信息和数据，请您保存好订单商品和服务的交易凭证、票据等资料， 否则您有可能须支付额外的账户和订单查询费用，或无法享受售后服务。</div>
      </div>
      <div>
        <div class="title-subhead">3.在携康账户注销期间，如果您的携康账户涉及争议纠纷，包括但不限于投诉、举报、诉讼、仲裁、国家有权机关调查等，携康有权自行终止服务注销程序而无需另行得到您的同意。
      </div>
      <div>
        <div class="title-subhead">4.注销携康账户，您将无法再使用本携康账户，您使用该账户登录的客户端、网页等将被退出登录， 无法再次使用此账户进行登录，也将无法找回您携康账户中及与账户相关的任何内容或信息， 包括但不限于：</div>
        <div class="list-text">
          （1）您将无法登录、使用本携康账户；
        </div>
        <div class="list-text">
          （2）本携康账户的个人资料和历史信息（包括但不限于用户名、头像、购物记录、关注信息等）都将无法找回， 请确认所有交易已完成且无纠纷，账户注销后因历史交易产生的纠纷及维权相关的资金将无法退还给您；
        </div>
        <div class="list-text">
          （3）您通过携康获得的红包、账户余额、健康币、优惠券、权益、积分、资格等视为您自行放弃，将无法继续使用。您理解并同意，携康无法协助您重新恢复前述服务。
        </div>
      </div>
      <div>
        <div class="title-subhead">5.请您注意，注销本携康账户并不代表本携康账户注销前的账户行为和相关责任得到豁免或减轻。</div>
      </div>
    </div>
        </div>
  </div>
</template>
<script>
export default {
  name: 'protocol',
  components: {

  },
  data () {
    return {

    }
  },
  beforeCreate () {

  },
  created () {

  },
  mounted () {

  },
  methods: {

  }
}
</script>

<style scoped lang="less">
/*公共样式*/
html {
  -webkit-text-size-adjust: none;
  -webkit-appearance: none;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  touch-action: none;
}

body {
  height: 100%;
  user-select: none;

}

body * {
  user-select: inherit;
}

body .user-select {
  user-select: initial;
}

a,
h1,
h2,
h3,
img,
body,
html,
ul,
li,
p {
  margin: 0;
  padding: 0;
}

img {
  border: 0;
  vertical-align: middle;
}

.clearfix:after {
  display: block;
  clear: both;
  content: "";
  visibility: hidden;
  height: 0;
}

.clearfix {
  zoom: 1;
}

.fl {
  float: left;
}

.fr {
  float: right;
}

li {
  list-style: none;
}

a {
  text-decoration: none;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}
.container{
  font-size: 0.28rem;
  margin: 0 0.32rem;
  color:#333;
  overflow: auto;
}
.title{
  font-size: 32px;
  font-weight: bold;
  padding: 0.5rem 0 0.2rem;
}
.privacy-title{

  font-size: 0.4rem;
  font-weight: bold;
  padding:0.5rem 0;
}
.title-subhead{
  font-size: 34px;
  font-weight: bold;
  padding:0.3rem 0;
  line-height: 1.6em;
}
.list-text{
  text-indent: 0.5rem;
  line-height: 1.6em;
  padding-bottom: 0.1rem;
  font-size: 32px;
}
.subhead{
  font-weight: bold;
  text-indent: 0.5rem;
  padding-bottom: 0.1rem;
}
.privacy-subhead{
  font-weight: bold;
  padding-bottom: 0.1rem;
}
.company-text{
  padding-top: 0.4rem;
}
.time{
  padding-top: 0.1rem;
  padding-bottom: 0.2rem;
}
.padding-bottom{
  padding-bottom: 0.1rem;
}

</style>
